/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zusatzvereinbarungversendet1Inputs */

const de__field_zusatzvereinbarungversendet1 = /** @type {(inputs: _Field_Zusatzvereinbarungversendet1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzvereinbarung versendet`)
};

/**

* @param {_Field_Zusatzvereinbarungversendet1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zusatzvereinbarungversendet1 = /** @type {((inputs?: _Field_Zusatzvereinbarungversendet1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zusatzvereinbarungversendet1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zusatzvereinbarungversendet1(inputs)
});
export { _field_zusatzvereinbarungversendet1 as "_field_zusatzvereinbarungVersendet" }